import Vue from 'vue/dist/vue.esm'
import clickOutside from './click-outside'

Vue.directive('click-outside', clickOutside)